import { createContext, useState, useCallback } from 'react';

type InvoiceDataContextType = {
  isBlockedForCardPayments: boolean;
  cardFeePercentage: number;
  creditsBalance: number;
  useCredits: boolean;
  setInvoiceData: (data: {
    isBlockedForCardPayments?: boolean;
    cardFeePercentage?: number;
    creditsBalance?: number;
  }) => void;
  setUseCredits: (value: boolean) => void;
};

const InvoiceDataContext = createContext<InvoiceDataContextType>({
  isBlockedForCardPayments: false,
  cardFeePercentage: 0,
  creditsBalance: 0,
  useCredits: false,
  setInvoiceData: () => {},
  setUseCredits: () => {},
});

const InvoiceDataProvider = ({ children }: React.PropsWithChildren): JSX.Element => {
  const [isBlockedForCardPayments, setIsBlockedForCardPayments] = useState(false);
  const [cardFeePercentage, setCardFeePercentage] = useState(0);
  const [creditsBalance, setCreditsBalance] = useState(0);
  const [useCredits, setUseCredits] = useState(false);

  const setInvoiceData = useCallback(
    (data: {
      isBlockedForCardPayments?: boolean;
      cardFeePercentage?: number;
      creditsBalance?: number;
    }) => {
      if (data.isBlockedForCardPayments !== undefined) {
        setIsBlockedForCardPayments(data.isBlockedForCardPayments);
      }
      if (data.cardFeePercentage !== undefined) {
        setCardFeePercentage(data.cardFeePercentage);
      }
      if (data.creditsBalance !== undefined) {
        setCreditsBalance(data.creditsBalance);
      }
    },
    []
  );

  return (
    <InvoiceDataContext.Provider
      value={{
        isBlockedForCardPayments,
        cardFeePercentage,
        creditsBalance,
        useCredits,
        setInvoiceData,
        setUseCredits,
      }}
    >
      {children}
    </InvoiceDataContext.Provider>
  );
};

export default InvoiceDataContext;
export { InvoiceDataProvider };
